import * as React from 'react';
import { connect } from 'react-redux';

import 'floating-label-react/styles.css';
import Message from './Message';
import Loader from '../Loader';

import {
  Button, 
  Input, 
  Switch,
  Card,
} from '../../ui';
import {
  setStepInnerPage
} from "../../../actions";
import authActions from '../../../actions/auth';
import { auth } from "../../../operations";

import {
  validateEmail, 
  validatePassword, 
  validateCI, 
  validateRUT, 
  TIPO_DOC
} from '../../../helpers';

import iconUser from '../../../assets/icons/icon-user.svg';
import iconEmail from '../../../assets/icons/icon-email.svg';
import iconPass from '../../../assets/icons/icon-pass.svg';
import iconNumber from '../../../assets/icons/icon-number.svg';
import iconFolder from '../../../assets/icons/icon-folder.svg';

const PASSWORD_FORMAT_MESSAGE = 'La contraseña debe tener un largo minimo de 8 caracteres, al menos una mayúscula y una minúscula, y un número (0-9), y no contener sus documentos.';
const INITIAL_STATE = {
  name: '',
  lastName: '',
  email: '',
  password: '',
  repeatPassword: '',
  ci: '',
  ciInsuranceNumber: '',
  rut: '',
  rutInsuranceNumber: '',
  isForeignDocument: false,
  foreignDocumentAssuredNumber: '',
  foreignDocumentInsuranceNumber: '',
  error: ''
};

class Register extends React.Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
    
    const { authReset } = this.props;
    authReset();
  }

  handleOnChange = (event) => {
    const {
      target: {
        name: field, type, checked, value: targetValue
      }
    } = event;
    const value = type === 'checkbox' ? checked : targetValue;

    this.setState({ [field]: value });
  }
  
  handleOnRegisterClick = () => {
    const {
      name, lastName, email, password, repeatPassword,
      isForeignDocument, foreignDocumentAssuredNumber, foreignDocumentInsuranceNumber,
      ci, ciInsuranceNumber, rut, rutInsuranceNumber
    } = this.state;
    let error = '';
    if (!name) error = 'Debe completar su nombre.';
    else if (!lastName) error = 'Debe completar su apellido o razón social.';
    else if (!email) error = 'Debe completar su email.';
    else if (email && !validateEmail(email)) error = 'El formato del email no es correcto.';

    else if (isForeignDocument && !foreignDocumentAssuredNumber) error = 'Debe completar su número de asegurado.';
    else if (!isForeignDocument && !ci && !rut) error = 'Debe completar su Cédula de Identidad o su número de Rut.';
    else if (!isForeignDocument && ci && !validateCI(ci)) error = 'El formato de la Cédula de Identidad no es correcto.';
    else if (!isForeignDocument && rut && !validateRUT(rut)) error = 'El formato del RUT no es correcto.';

    else if (!password) error = 'Debe completar la contraseña.';
    else if (!repeatPassword) error = 'Debe repetir la contraseña.';
    else if (password !== repeatPassword) error = 'Las contraseñas deben coincidir.';
    else if (!validatePassword(password, ci, rut, foreignDocumentAssuredNumber)) error = 'La contraseña no cumple con las reglas de seguridad.';

    if (!error) {
      const { onRegisterClick } = this.props;

      this.setState({ error: '' });
      const client = {
        name, lastName, email, password, isForeignDocument
      };

      if (isForeignDocument) {
        client.foreignDocumentAssuredNumber = foreignDocumentAssuredNumber;
        client.foreignDocumentInsuranceNumber = foreignDocumentInsuranceNumber;
      } else {
        client.ci = ci;
        client.ciInsuranceNumber = ciInsuranceNumber;
        client.rut = rut;
        client.rutInsuranceNumber = rutInsuranceNumber;
      }

      onRegisterClick(client);
    } else {
      this.setState({ error });
    }
  }

  renderFormInputs() {
    const { error } = this.state;
    const isError = error !== '';

    return (
      <div className="Register-inputs">
        <form>
          {/* Cliente */}
          {this.renderClientFields(isError)}

          {/* Documentos */}
          {this.renderDocumentFields(isError)}

          {/* Contraseña */}
          {this.renderPasswordFields(isError)}
        </form>
      </div>
    );
  }

  renderClientFields = (isError: boolean) => {
    const { name, lastName, email } = this.state;

    return (
      <div>
        <Input
          id="name"
          name="name"
          placeholder="Nombre"
          maxLength="50"
          type="text"
          value={name}
          onChange={this.handleOnChange}
          leftIcon={iconUser}
          showAlert={isError && !name}
          autoComplete="nope"
        />

        <Input
          id="lastName"
          name="lastName"
          placeholder="Apellido o Razón Social"
          maxLength="50"
          type="text"
          value={lastName}
          onChange={this.handleOnChange}
          leftIcon={iconUser}
          showAlert={isError && !lastName}
          autoComplete="nope"
        />

        <Input
          id="email"
          name="email"
          placeholder="Email"
          maxLength="50"
          type="email"
          value={email}
          onChange={this.handleOnChange}
          leftIcon={iconEmail}
          showAlert={isError && !validateEmail(email)}
          autoComplete="nope"
        />
      </div>
    )
  }

  renderDocumentFields = (isError: boolean) => {
    const {
      ci, ciInsuranceNumber, rut, rutInsuranceNumber,
      isForeignDocument, foreignDocumentAssuredNumber, foreignDocumentInsuranceNumber
    } = this.state;

    const {
      onPolicyMailClick,
      sendingPolicy
    } = this.props;

    return (
      <React.Fragment>
        <Switch
          label="Registrarme con documento extranjero"
          isOn={isForeignDocument}
          handleToggle={this.handleOnChange}
          name="isForeignDocument"
        />

        {isForeignDocument
          ? (
            <React.Fragment>
              <Input
                id="foreignDocumentAssuredNumber"
                name="foreignDocumentAssuredNumber"
                placeholder="Número de Asegurado"
                maxLength="50"
                type="text"
                value={foreignDocumentAssuredNumber}
                onChange={this.handleOnChange}
                leftIcon={iconNumber}
                showAlert={isError && !foreignDocumentAssuredNumber}
                autoComplete="nope"
              />

              <Input
                id="foreignDocumentInsuranceNumber"
                name="foreignDocumentInsuranceNumber"
                placeholder="Póliza asociada al número de asegurado"
                maxLength="50"
                type="text"
                value={foreignDocumentInsuranceNumber}
                onChange={this.handleOnChange}
                leftIcon={iconFolder}
                autoComplete="nope"
              />

              {sendingPolicy ?
                <Loader /> :
                (
                  <Message
                    type={Message.Types.INFO}
                    message={[
                      `El número de póliza es necesario para poder validar tu número de asegurado, si no lo recuerdas te lo podemos `,
                      <Button link onClick={() => onPolicyMailClick(TIPO_DOC.ASSURED, foreignDocumentAssuredNumber)}>enviar por email</Button>,
                      "."
                    ]}
                  />
                )
              }
            </React.Fragment>
          )
          : (
            <React.Fragment>
              <Input
                id="ci"
                name="ci"
                placeholder="Documento de identidad"
                maxLength="50"
                type="number"
                value={ci}
                onChange={this.handleOnChange}
                leftIcon={iconNumber}
                showAlert={isError && ((!ci && !rut) || (ci && !validateCI(ci)))}
                autoComplete="nope"
              />

              <Input
                id="ciInsuranceNumber"
                name="ciInsuranceNumber"
                placeholder="Póliza asociada a Documento"
                maxLength="50"
                type="number"
                value={ciInsuranceNumber}
                onChange={this.handleOnChange}
                leftIcon={iconFolder}
                autoComplete="nope"
              />

              {sendingPolicy ?
                <Loader /> :
                (
                  <Message
                    type={Message.Types.INFO}
                    message={[
                      `El número de póliza es necesario para poder validar tu CI, si no lo recuerdas te lo podemos `,
                      <Button link onClick={() => onPolicyMailClick(TIPO_DOC.CI, ci)}>enviar por email</Button>,
                      "."
                    ]}
                  />
                )}
              <Input
                id="rut"
                name="rut"
                placeholder="RUT"
                maxLength="50"
                type="number"
                value={rut}
                onChange={this.handleOnChange}
                leftIcon={iconNumber}
                showAlert={isError && ((!ci && !rut) || (rut && !validateRUT(rut)))}
                autoComplete="nope"
              />

              <Input
                id="rutInsuranceNumber"
                name="rutInsuranceNumber"
                placeholder="Póliza asociada a RUT"
                maxLength="50"
                type="number"
                value={rutInsuranceNumber}
                onChange={this.handleOnChange}
                leftIcon={iconFolder}
                autoComplete="nope"
              />

              {sendingPolicy ?
                <Loader /> :
                (
                  <Message
                    type={Message.Types.INFO}
                    message={[
                      `El número de póliza es necesario para poder validar tu RUT, si no lo recuerdas te lo podemos `,
                      <Button link onClick={() => onPolicyMailClick(TIPO_DOC.RUT, rut)}>enviar por email</Button>,
                      "."
                    ]}
                  />
                )
              }
            </React.Fragment>
          )
        }
      </React.Fragment>
    );
  }

  renderPasswordFields = (isError: boolean) => {
    const { password, repeatPassword } = this.state;

    return (
      <div>
        <Input
          id="password"
          name="password"
          placeholder="Contraseña"
          maxLength="50"
          type="password"
          value={password}
          onChange={this.handleOnChange}
          leftIcon={iconPass}
          showAlert={isError && !password}
          autoComplete="new-password"
        />

        <Message
          type={Message.Types.INFO}
          message={PASSWORD_FORMAT_MESSAGE}
        />

        <Input
          id="repeatPassword"
          name="repeatPassword"
          placeholder="Repetir contraseña"
          maxLength="50"
          type="password"
          value={repeatPassword}
          onChange={this.handleOnChange}
          leftIcon={iconPass}
          showAlert={isError && !repeatPassword}
          autoComplete="nope"
        />
      </div>
    );
  }
          
  renderMessage() {
    const { error } = this.state;
    const { errorMessage, resultMessage } = this.props;
    return (
      <div className="Register-messageContainer">
        <Message
          type={Message.Types.ERROR}
          message={error || errorMessage}
        />
        <Message
          type={Message.Types.SUCCESS}
          message={resultMessage}
        />
      </div>
    );
  }

  renderButtons() {
    const { setStepInnerPage, isLoading } = this.props;
    return (
      <div className="Register-buttonsContainer">
        <Button
          onClick={this.handleOnRegisterClick}
          isLoading={isLoading}
        >
          Registrarme
        </Button>
        <Button plain onClick={() => { setStepInnerPage('login') }} className="Register-link">
          Volver al login
        </Button>
      </div>
    );
  }
  
  render() {
    return (
      <div>
        <Card.Header>Registro de usuario</Card.Header>
        {this.renderFormInputs()}
        {this.renderMessage()}
        {this.renderButtons()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.auth.errorMessage,
  resultMessage: state.auth.resultMessage,
  isLoading: state.auth.isLoading,
  sendingPolicy: state.auth.sendingPolicy,
});

const mapDispatchToProps = dispatch => ({
  authReset: () => {
    dispatch(authActions.authReset());
  },
  onRegisterClick: (client) => {
    dispatch(authActions.authRequest());
    dispatch(auth.registerClient(client));
  },
  onPolicyMailClick: (tipoDoc, nroDoc) => {
    dispatch(auth.sendPolicyByMail({tipoDoc, nroDoc}));
  },
  setStepInnerPage: (page) => {
    dispatch(setStepInnerPage(page));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
